import { Checkbox } from '@cian/ui-kit';
import { EWCType } from '../../../../../../../packages/api-models/common/json_query';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectUrbanBathroomFilter } from 'shared/selectors/advancedFilters';
import { SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const UrbanBathroomContainer: FC = () => {
  const {
    label,
    value,
    options,
    bathroomCountFilter: { label: bathroomCountLabel, value: bathroomCount },
  } = useSelector(selectUrbanBathroomFilter);

  const onChange = useFilterChangeCallback();

  const handleBathroomTypeChange = useCallback(
    (newValue: EWCType | null) => {
      onChange({ action: 'setUrbanBathroomType', arguments: [newValue] });
    },
    [onChange],
  );

  const handleBathroomCountMinChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setBathroomCountMin', arguments: [newValue ? 2 : null] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBathroomTypeChange} />
        </InlineFilter>

        <InlineFilter>
          <Checkbox label={bathroomCountLabel} checked={bathroomCount} onChange={handleBathroomCountMinChange} />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
